/*
 * @Author: wangyunwon
 * @Date: 2025-11-11 14:21:23
 * @Description: 纯粹时间选择器，不带日期选择
 */

import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import RichTimePicker from './layout.vue'
import { InputPreviewText } from '../PreviewText'

const TransformRichTimePicker = transformComponent(RichTimePicker, {
  change: 'input',
})

export const TimeNoDatePicker = connect(
  TransformRichTimePicker,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(InputPreviewText),
)

export default TimeNoDatePicker
